import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Device } from '../shared/interfaces/deviceInfo';
import { DataService, PopulationDevices } from '../shared/dataService';
import { AttLogChart } from '../shared/interfaces/attLog';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})


export class HomeComponent implements OnInit 
{
  public populationDevices : any[] = [];
  public dataSource : Device[] = [];
  public loadIndicatorVisible = false;
  public buttonText = "Send";
  public currentMode: string = "stagger";
  public loginRequired:boolean = false;
  constructor(private data:DataService,private router : Router) 
  {
    console.log("Init console HomeCompoenent");
    if (this.data.loginRequired) 
    {
      this.router.navigate(["/account"]);
    }
    else
    {
      this.loginRequired=true;
      this.router.navigate(["/"]);
    } 
  }
  
  public onCellClick(e)
  {
    console.log(e);
  } 
 
  public initDataSource()
  {
    this.data.loadDevices()
        .subscribe(sucess =>
        {
            if (sucess)
            {
              console.log(this.data.devices);
                this.dataSource = this.data.devices;
                let dataStateGroup =this.data.groupBy(this.dataSource,"state")

                this.initChartDevices(dataStateGroup);
               
            }
        });
  }
  initChartDevices(data:any)
  {
      //let item: PopulationDevices  = new PopulationDevices();
      /**estatus: SL,	Online,	Connecting,	Connection */
      if (data.SL != undefined)
      {
        let item =  {"status": "SL", "SL":data.SL.length }
        this.populationDevices.push(item); 
      }
      if (data.OffLine != undefined)
      {
        let item =  {"status": "OffLine", "OffLine": data.OffLine.length  }
        this.populationDevices.push(item); 
      }

      if (data.Online != undefined)
      {
        let item =  {"status": "Online", "Online": data.Online.length}
        this.populationDevices.push(item);
      }
      if (data.connecting != undefined)
      {
        let item =  {"status": "connecting", "connecting": data.connecting.length}
        if (data.connection != undefined)
        { 
          item.connecting += data.connection.length;
          this.populationDevices.push(item);  
        }
        else
          this.populationDevices.push(item);
      } 
    
  } 
 
  ngOnInit() 
  {  
      this.initDataSource();
  }


}
